module.exports = __webpack_public_path__ + "img/028-clipboard.80abcb26.svg";